/* eslint-disable import/prefer-default-export */
// Unfortunately, the available tactics are not defined on the server; it is up to the front-end to expose it.
const TARGETING_TACTICS = {
  EXCHANGES: { key: 'EXCHANGES', label: 'Exchange Targeting' },
  BLACKLISTED_CATEGORIES: { key: 'BLACKLISTED_CATEGORIES', label: 'App Category Exclusion' },
  WHITELISTED_CATEGORIES: { key: 'WHITELISTED_CATEGORIES', label: 'App Category Inclusion' },
  WHITELISTED_DEVICES: { key: 'WHITELISTED_DEVICES', label: 'Included Devices' },
  BLACKLISTED_DEVICES: { key: 'BLACKLISTED_DEVICES', label: 'Excluded Devices' },
  BRANDSAFE_SCORES: { key: 'BRANDSAFE_SCORES', label: 'Brand Safety Score Targeting' },
  BLACKLISTED_CARRIERS: { key: 'BLACKLISTED_CARRIERS', label: 'Excluded Carriers' },
  WHITELISTED_CARRIERS: { key: 'WHITELISTED_CARRIERS', label: 'Included Carriers' },
  WHITELISTED_APP_NAMES: false, // not used in ventura
  BLACKLISTED_APP_NAMES: false, // not used in ventura
  BLACKLISTED_APP_AD_SPACE_IDS: { key: 'BLACKLISTED_APP_AD_SPACE_IDS', label: 'Ad Space ID Exclusion' },
  WHITELISTED_GENDERS: { key: 'WHITELISTED_GENDERS', label: 'Included Genders' },
  DEVICE_COUNTRIES: false, // excluded from tactics picker, always true in new DSP
  WHITELISTED_STATE_IDS: { key: 'WHITELISTED_STATE_IDS', label: 'State Inclusion' }, // show this only when line item target_strategy is geocookie
  WHITELISTED_NIELSEN_DMAS: { key: 'WHITELISTED_NIELSEN_DMAS', label: 'DMA Inclusion' }, // show this only when line item target_strategy is geocookie
  WHITELISTED_APP_AD_SPACE_IDS: { key: 'WHITELISTED_APP_AD_SPACE_IDS', label: 'Ad Space ID Inclusion' },
  VIDEO_SIZE_TARGETING: false, // not used in ventura
  HOURS: { key: 'HOURS', label: 'Time Targeting' },
  WEATHER: false, // not used in ventura
  POLLEN_COUNT: false, // not used in ventura
  LOCATION_SCORES: { key: 'LOCATION_SCORES', label: 'Location Score Targeting' },
  AGE_TARGETING: { key: 'AGE_TARGETING', label: 'Age Targeting' },
  app_blacklist_threshold: { key: 'app_blacklist_threshold', label: 'CTR Tier Exclusion' }, // show this only when line item media_type is display
  app_whitelist_tier: { key: 'app_whitelist_tier', label: 'CTR Tier Inclusion' }, // show this only when line item media_type is display
  min_conversion_rate: { key: 'min_conversion_rate', label: 'Conversion Rate Inclusion' },
  conversion_rate_exclusion: { key: 'conversion_rate_exclusion', label: 'Conversion Rate Exclusion' },
  TEMPERATURE: false, // not used in ventura
  UV_INDEX: false, // not used in ventura
  VIDEO_SKIPPABILITY: { key: 'VIDEO_SKIPPABILITY', label: 'Video Skippability Targeting' },
  APP_OR_SITE: { key: 'APP_OR_SITE', label: 'App Or Site' },
  deal_ids: { key: 'deal_ids', label: 'Deal IDs' },
  restricted_targeting: { key: 'restricted_targeting', label: 'Restricted Targeting' },
  WHITELISTED_BUNDLE_IDS: { key: 'WHITELISTED_BUNDLE_IDS', label: 'A_S_ID Inclusion' },
  BLACKLISTED_BUNDLE_IDS: { key: 'BLACKLISTED_BUNDLE_IDS', label: 'A_S_ID Exclusion' },
  INCLUDED_APP_BUNDLES: { key: 'INCLUDED_APP_BUNDLES', label: 'Bundle ID Inclusion' },
  EXCLUDED_APP_BUNDLES: { key: 'EXCLUDED_APP_BUNDLES', label: 'Bundle ID Exclusion' },
  app_vcr_blacklist_threshold: { key: 'app_vcr_blacklist_threshold', label: 'VCR Tier Exclusion' }, // show this only when line item media_type is video
  app_vcr_whitelist_tier: { key: 'app_vcr_whitelist_tier', label: 'VCR Tier Inclusion' }, // show this only when line item media_type is video
  VIDEO_AD_POSITION: { key: 'VIDEO_AD_POSITION', label: 'Video Ad Position Targeting' },
  whitelisted_deal_ids: false, // hidden from UI - not used by ad ops
  needs_tn_user_id: { key: 'needs_tn_user_id', label: 'Needs TN User ID' },
  location_fetch_enabled: { key: 'location_fetch_enabled', label: 'Location Fetch-Enabled' },
  dv_custom_segment_inclusion: { key: 'dv_custom_segment_inclusion', label: 'DV Custom Segment Inclusion' },
  dv_custom_segment_exclusion: { key: 'dv_custom_segment_exclusion', label: 'DV Custom Segment Exclusion' },
  dv_ivt_prebid_filter: { key: 'dv_ivt_prebid_filter', label: 'DV IVT Pre-bid Filter' },
};

export default TARGETING_TACTICS;
